module.exports = __webpack_public_path__ + "img/change1.cdd1ce5f.png";